import { Button as FloraButton, Flex, keyframes, styled } from '@grupoboticario/flora-react'

const rollUp = keyframes({
  '0%': { transform: 'translateY(66px)' },
  '100%': { transform: 'translateY(0)' },
})

export const Wrapper = styled(Flex, {
  backgroundColor: '$success-standard',
  position: 'fixed',
  width: '100%',
  height: 66,
  bottom: 0,
  zIndex: 1000,
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px 8px 0px 0px',
  boxShadow: '0px -4px 24px -8px rgba(0, 0, 0, 0.4)',
  animation: `${rollUp} 0.5s`,
})

export const Button = styled(FloraButton, {
  width: '100%',
})
